/**
 * Card
 * Reusable styled card component
 */
import type { PropsWithChildren } from 'react';
import styled from 'styled-components';

const CardStyle = styled.div<
  PropsWithChildren<{
    borderRadius?: string;
    borderless?: boolean;
    unshadowed?: boolean;
    shadowed?: boolean;
    backgroundColor?: string;
    width?: string;
    fixWidth?: boolean;
    inline?: boolean;
    padding?: string;
    overflow?: string;
    cursor?: string;
  }>
>`
  box-sizing: border-box;
  border-radius: ${(props) => props.borderRadius};
  ${({ borderless, theme }) =>
    !borderless && `border: 1px solid ${theme.palette.divider};`}

  ${({ unshadowed, borderless, theme }) =>
    !unshadowed && !borderless && `box-shadow: ${theme.shadows[1]}`}
    
  background-color: ${(props) => props.theme.palette.background.paper};
  margin: 0 0 10px 0;
  width: ${(props) => props.width};
  min-width: ${(props) => (props.fixWidth ? props.width : 'initial')};
  display: ${(props) => (props.inline ? 'inline-block' : 'block')};
  min-height: 5px;
  padding: ${(props) => props.padding};
  overflow: ${(props) => props.overflow};
  align-items: center;
  position: relative;
  cursor: ${(props) => props.cursor};

  &:hover {
    ${({ unshadowed, borderless, theme }) =>
      !unshadowed && !borderless && `box-shadow: ${theme.shadows[1]}`}
  }
`;

CardStyle.defaultProps = {
  borderRadius: '8px',
  borderless: false,
  cursor: 'auto',
  fixWidth: false,
  inline: false,
  overflow: 'visible',
  padding: '10px',
  shadowed: false,
  unshadowed: false,
  width: '100%',
};

export default CardStyle;
